<template>
  <div class="app-coupon">
    <coupon
      v-model="valueCoupon"
      :button-text="buttonText"
      :is-successful="applyingCouponSuccess"
      :is-error="applyingCouponError"
      :is-loading="applyingCoupon"
      :error-text="errorText"
      autocomplete="off"
      @apply="handlerApplyCoupon"
      @remove="handlerRemoveAppliedCoupon"
    >
      <template v-if="showIcon" #icon>
        <promocode16 class="app-coupon__icon" :width="16" :height="16" />
      </template>
    </coupon>
    <notification
      v-if="descriptionCoupon"
      class="app-coupon__notification"
      type="warning"
      :is-show-back="false"
      :is-container="false"
    >
      {{ descriptionCoupon }}
    </notification>
  </div>
</template>

<script>
import { defineComponent, watch } from '@vue/composition-api';
import { Coupon, Notification } from '@book24/ui-components';

import Promocode16 from '@/assets/sprite/svg/16/Promocode_16.svg';

import useCoupon from '@/compositions/useCoupon';

export default defineComponent({
  name: 'AppCoupon',
  components: {
    Coupon,
    Notification,
    Promocode16,
  },
  props: {
    buttonText: { type: String, default: 'Применить' },
    showIcon: { type: Boolean, default: true },
    isFetchBasket: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const coupon = useCoupon({ isFetchBasket: props.isFetchBasket });

    const handlerApplyCoupon = async () => {
      await coupon.applyPromoCode()
        .then(() => emit('couponChanged'));
    };

    const handlerRemoveAppliedCoupon = async () => {
      await coupon.removePromoCode()
        .then(() => emit('couponChanged'));
    };

    watch(
      () => coupon.isFirstRender.value,
      (value) => {
        emit('changeShowCoupon', !value);
      },
      { immediate: true },
    );

    return {
      valueCoupon: coupon.valueCoupon,
      descriptionCoupon: coupon.descriptionCoupon,
      applyingCouponSuccess: coupon.applyingCouponSuccess,
      applyingCouponError: coupon.applyingCouponError,
      applyingCoupon: coupon.applyingCoupon,
      errorText: coupon.errorText,
      handlerApplyCoupon,
      handlerRemoveAppliedCoupon,
    };
  },
});
</script>

<style lang="less">
.app-coupon {
  &__icon {
    fill: @gray;
  }

  &__notification {
    margin-top: @size-x6;
  }

  & input {
    text-transform: uppercase;

    &::placeholder {
      text-transform: none;
    }
  }
}
</style>
